import React, { useState } from "react";
import { generateMaterial } from "../utils/generateMaterial";
import { db } from "../firebase"; // assuming you already have firebase.js
import { collection, addDoc, serverTimestamp } from "firebase/firestore";

const DiscoverMaterialButton = ({
  currentLocation,
  currentEvent,
  adventureLogs,
}) => {
  const [loading, setLoading] = useState(false);
  const [newMaterial, setNewMaterial] = useState(null);

  const handleDiscoverMaterial = async () => {
    setLoading(true);
    console.log("⚙️ Generating material...");

    const material = await generateMaterial(
      currentLocation,
      currentEvent,
      adventureLogs
    );

    console.log("🧪 Received material:", material);

    if (material) {
      setNewMaterial(material);
      await saveDiscoveredMaterial(material); // <<<<<< ADD THIS LINE
    } else {
      console.warn("❌ Material generation failed or returned null.");
    }

    setLoading(false);
  };

  const saveDiscoveredMaterial = async (material) => {
    try {
      await addDoc(collection(db, "discoveredMaterials"), {
        ...material,
        discoveredAt: serverTimestamp(),
        discoveredBy: "DM", // optional, you can make it dynamic later
      });
      console.log("Material saved to Firestore!");
    } catch (error) {
      console.error("Failed to save material:", error);
    }
  };

  return (
    <div
      style={{
        marginTop: "1rem",
        padding: "1rem",
        background: "#eef",
        borderRadius: "8px",
      }}
    >
      <button
        onClick={handleDiscoverMaterial}
        disabled={loading}
        style={{
          background: "purple",
          color: "white",
          padding: "10px 20px",
          border: "none",
          borderRadius: "6px",
          fontSize: "1rem",
          cursor: "pointer",
        }}
      >
        {loading ? "Generating..." : "✨ Discover New Material"}
      </button>

      {newMaterial && (
        <div
          style={{
            marginTop: "1rem",
            background: "white",
            padding: "1rem",
            borderRadius: "8px",
          }}
        >
          <h4>🧪 New Material Discovered!</h4>
          <p>
            <strong>Name:</strong> {newMaterial.name}
          </p>
          <p>
            <strong>Description:</strong> {newMaterial.description}
          </p>
          <p>
            <strong>Quality:</strong> {newMaterial.quality}
          </p>
          <p>
            <strong>Rarity:</strong> {newMaterial.rarity}
          </p>
        </div>
      )}
    </div>
  );
};

export default DiscoverMaterialButton;
